import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { COLORS } from '../../../data/colors';

@Component({
  selector: 'color-binder',
  templateUrl: './color-binder.html',
  styleUrls: ['./color-binder.css']
})
export class ColorBinder implements OnInit {

	popupOpened: boolean = false;
  colorsList: Array<any> = [];
  colorOfBinded: string = '';
  currentSelectedColor: string = '';
  defaultColors: Array<any> = COLORS;

  constructor ( ) { }

  @Input( ) 
  bindedColors: Array<any> = [];
  @Input( ) 
  currentBinding: string = '';
  @Input( ) 
  customTitle: string = '';
  @Input( ) 
  currentSelectedColorID: any = -1;

  @Output( ) 
  onClickColor = new EventEmitter<any>( );


  // Immidiately call function to bind data
  ngOnInit ( ) {
  	this.bindData( );
  }

  // Binding data, we already have
  bindData ( ) {

  	this._clearData( );

  	let _i;
  	let _j;
  	let _bd;
  	let _lc;

    if ( this.currentSelectedColorID !== 0 ) {
      if ( !this.currentSelectedColorID || this.currentSelectedColorID < 0 ) this.currentSelectedColorID = -1;
    }

  	for ( _j = 0; _j < this.bindedColors.length; ++_j ) {
	  	_bd = this.bindedColors[_j];
  		if ( _bd.bindedDataTitle == this.currentBinding ) this.colorOfBinded = _bd.color;
  	}

  	for ( _i = 0; _i < this.colorsList.length; ++_i ) {
  		_lc = this.colorsList[_i];
      if ( this.currentSelectedColorID !== -1 && this.currentSelectedColorID === _lc.colorID ) this.currentSelectedColor = _lc.color;
	  	for ( _j = 0; _j < this.bindedColors.length; ++_j ) {
	  		_bd = this.bindedColors[_j];
  			if ( _bd.colorID === _lc.colorID ) {
          this.colorsList[_i].bindedData = _bd.bindedData;
          if ( _bd.clickable === false ) this.colorsList[_i].clickable = false;
        }
	  	}
  	}

  }

  // Clearing Data before binding
  _clearData ( ) {
  	this.colorsList = [];
  	this.defaultColors.forEach( _color => this.colorsList.push( { clickable: true, color: _color.color, bindedData: '', colorID: _color.colorID } ) );
  }

  // Select the color
  selectColor ( selectedColor: string, id: number, clickable: boolean ) {

  	// let _alreadyBinded: boolean = false;

  	// this.colorsList.forEach( _data => {
  	// 	if ( _data.color == selectedColor ) {
  	// 		if ( _data.bindedData !== '' ) _alreadyBinded = true;
  	// 	}
  	// });

  	if ( clickable ) {
  		this.colorOfBinded = selectedColor;
  		this.onClickColor.emit( { color: selectedColor, colorID: id } );
  		this.closePopup( );
  	}

		return false;
  }

  closePopup( ) { this.popupOpened = false; }
  openPopup( ) {
  	this.bindData( );
    // console.log( 'Colors List:', this.colorsList );
    // console.log( 'Bindings:', this.bindedColors );
  	this.popupOpened = true;
  }

}


// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/color-binder/color-binder.ts